function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M24.3203 29.5898C23.8789 30.0234 23.3633 30.2402 22.7734 30.2402C22.0195 30.2402 21.416 29.9824 20.9629 29.4668C20.5098 28.9473 20.2832 28.248 20.2832 27.3691C20.2832 26.8105 20.4043 26.2988 20.6465 25.834C20.8926 25.3652 21.2344 25.002 21.6719 24.7441C22.1094 24.4824 22.6016 24.3516 23.1484 24.3516C23.7109 24.3516 24.2109 24.4922 24.6484 24.7734C25.0859 25.0547 25.4258 25.459 25.668 25.9863C25.9102 26.5137 26.0332 27.1172 26.0371 27.7969V28.4238C26.0371 29.8457 25.6836 30.9629 24.9766 31.7754C24.2695 32.5879 23.2676 33.0215 21.9707 33.0762L21.5547 33.082V31.6699L21.9297 31.6641C23.4023 31.5977 24.1992 30.9062 24.3203 29.5898ZM23.1895 28.9453C23.4629 28.9453 23.6973 28.875 23.8926 28.7344C24.0918 28.5938 24.2422 28.4238 24.3438 28.2246V27.5273C24.3438 26.9531 24.2344 26.5078 24.0156 26.1914C23.7969 25.875 23.5039 25.7168 23.1367 25.7168C22.7969 25.7168 22.5176 25.873 22.2988 26.1855C22.0801 26.4941 21.9707 26.8828 21.9707 27.3516C21.9707 27.8164 22.0762 28.1992 22.2871 28.5C22.502 28.7969 22.8027 28.9453 23.1895 28.9453ZM30.7363 28.2246H32.8516V29.7539H30.7363V32.1445H29.125V29.7539H27.0039V28.2246H29.125V25.9336H30.7363V28.2246Z",
  fill: "black"
});

function SvgCartMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartMore);
export default __webpack_public_path__ + "static/media/cartMore.a285fa02.svg";
export { ForwardRef as ReactComponent };